module.exports = __webpack_public_path__ + "img/code.c3f8c71f.png";